import ApiUtil from '../util/ApiUtil';
import Constants from '../constants/Constants';
import {CancelTokenSource, AxiosResponse, AxiosRequestConfig} from 'axios';

const collabBaseUrl = '/api/v1/collaborationinvitation';

export interface ICollaborationInvitationSendQueryParams {
   IsResend: boolean;
   RecipientEmailAddress: string;
   CollaborationResourceRoles: ICollaborationResourceRoleModel[];
}

export interface ICollaborationInvitationGetInvitations {
   teamId: string;
}

export interface ICollaborationInvitationModel {
   InvitationToken: string;
   RecipientEmailAddress: string;
   CollaborationResourceRoles: ICollaborationResourceRoleModel[];

}
export interface ICollaborationResourceRoleModel {
   ResourceId: string;
   CollaborationRole: CollaborationRole;
   CollaborationResourceType: string;
}

export enum CollaborationRole {
   Unknown = 'Unknown',
   Owner = 'Owner',
   Editor = 'Editor',
   Reader = 'Reader'
}

const sendInvite = async (queryParams?: Partial<ICollaborationInvitationSendQueryParams[]>, CancellationToken?: CancelTokenSource): Promise<void> => {
   const url = `${collabBaseUrl}/send`;

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;
   await ApiUtil.executePostAsync(url, [Constants.statusCodes.noContent], queryParams, requestConfig);
};

const getInvite = async (invitationToken: string, CancellationToken?: CancelTokenSource): Promise<ICollaborationInvitationModel> => {
   const url = `${collabBaseUrl}/getInvitation/${invitationToken}`;

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;

   const response: AxiosResponse = await ApiUtil.executeGetAsync(url, [Constants.statusCodes.ok, Constants.statusCodes.notFound], requestConfig);
   return response.data as ICollaborationInvitationModel;
};

const getInvites = async (queryParams?: Partial<ICollaborationInvitationGetInvitations>, CancellationToken?: CancelTokenSource): Promise<ICollaborationInvitationModel[]> => {
   const uniqueParam = `timestamp=${new Date().getTime()}`;
   const url = `${collabBaseUrl}/getInvitations/${queryParams.teamId}?${uniqueParam}`;

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;

   try {
      const response: AxiosResponse = await ApiUtil.executeGetAsync(url, [Constants.statusCodes.ok, Constants.statusCodes.notFound], queryParams, requestConfig);
      return response.data as ICollaborationInvitationModel[];
   } catch (e) {
      return [];
   }
};

const acceptInvite = async (invitationToken: string, CancellationToken?: CancelTokenSource): Promise<void> => {
   const url = `${collabBaseUrl}/acceptInvitation/${invitationToken}`;

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;
   await ApiUtil.executePostAsync(url, [Constants.statusCodes.noContent], requestConfig);
};

const deleteInvite = async (invitationToken: string, CancellationToken?: CancelTokenSource): Promise<void> => {
   const url = `${collabBaseUrl}/deleteInvitation/${invitationToken}`;

   const requestConfig: AxiosRequestConfig = CancellationToken ? {cancelToken: CancellationToken.token} : null;
   await ApiUtil.executeDeleteAsync(url, [Constants.statusCodes.noContent], requestConfig);
};

export default {
   sendInvite,
   getInvite,
   getInvites,
   acceptInvite,
   deleteInvite
};